import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import { __awaiter } from "tslib";
/* eslint-disable no-param-reassign */
import 'intersection-observer';
import isEqual from 'lodash-es/isEqual';
import cookie from '@tencent/vft-common/cookie';
import { getUid, getVuid } from '@tencent/vft-common/login/index.esm';
import { loginType } from '@tencent/vft-common/login/lib';
import { getAIDPlatform as getPlatform } from '@tencent/vft-common/platform';
import storage from '@tencent/vft-common/Storage/session';
import { getUrlParam } from '@tencent/vft-common/util.esm';
import { BindingTypes, EventType, ReportElementType } from "../../defs";
import { getPvid, isPromisable, mapDt2BossParams, normalizePath } from "../../util";
/**
 * 预置上报参数
 * @type { ReportParams }
 */
export var presetParams = {
  /** url链接 */
  f_url: normalizePath(location.pathname),
  /** 域名（H5上报） */
  f_dm: location.host,
  /** 域名协议 */
  f_protocol: location.protocol,
  /** url参数，如果含有$，需要用|||替换，再上报 */
  f_url_param: location.search.split('?')[1] || '',
  /** ptag，优先取url中ptag参数，如果没有则取aid的13级； */
  f_pagetag: getUrlParam('ptag', location.href) || storage.get('ptag') || cookie.get('ptag'),
  f_pt: getPlatform(),
  hc_pvid: getPvid()
};
var BossReporter = /*#__PURE__*/function () {
  function BossReporter(options, reportClient) {
    _classCallCheck(this, BossReporter);
    var _a, _b;
    this.queue = [];
    this.hasRealtimePVReported = false;
    this.reportClient = reportClient;
    this.presetParams = Object.assign({}, presetParams);
    this.init(options);
    this.observer = this.createObserver(options.observerOptions);
    this.enableRealtimePV = (_a = options.enableRealtimePV) !== null && _a !== void 0 ? _a : true;
    this.autoReportPVOnReady = (_b = options.autoReportPVOnReady) !== null && _b !== void 0 ? _b : true;
    if (this.shouldReportRealtimePV()) {
      this.reportRealtimePV();
    }
  }
  _createClass(BossReporter, [{
    key: "init",
    value: function init() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        extraParams = _ref.extraParams,
        delay = _ref.delay;
      extraParams && (this.extraParams = extraParams);
      this.delay = delay !== null && delay !== void 0 ? delay : this.delay;
    }
  }, {
    key: "ready",
    value: function ready() {
      this.delay = false;
      this.loginParams = this.buildLoginParams();
      if (this.autoReportPVOnReady) {
        this.pv();
      }
      var queueItem;
      while (queueItem = this.queue.shift()) {
        var _queueItem = queueItem,
          _queueItem2 = _slicedToArray(_queueItem, 2),
          params = _queueItem2[0],
          event = _queueItem2[1];
        this.report(params, event);
      }
      return Promise.resolve();
    }
  }, {
    key: "report",
    value: function report(params) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EventType.EXPOSE;
      var isRealtime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reportParams;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (params) {
                  _context.next = 2;
                  break;
                }
                throw new Error('[Boss Report] report params is required');
              case 2:
                if (!(this.delay && !isRealtime)) {
                  _context.next = 5;
                  break;
                }
                this.queue.push([params, event]);
                return _context.abrupt("return");
              case 5:
                _context.next = 7;
                return this.buildReportParams(params, event);
              case 7:
                reportParams = _context.sent;
                this.reportClient.report(reportParams, event);
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setExtraParams",
    value: function setExtraParams(params) {
      this.presetParams = Object.assign(Object.assign({}, this.presetParams), params);
    }
  }, {
    key: "useDirective",
    value: function useDirective(el, binding) {
      var _this = this;
      var _a;
      var type = binding.type,
        hook = binding.hook,
        once = binding.once,
        module = binding.module,
        value = binding.value;
      if (!value) {
        console.warn("[v-report:".concat(hook, "] \u4E0A\u62A5\u53C2\u6570\u4E3A\u7A7A"), el);
      }
      if (hook === 'unbind' || !value) {
        if ((_a = el.report) === null || _a === void 0 ? void 0 : _a.click) {
          el.removeEventListener('click', el.report.click, true);
          el.report.click = null;
        }
        if (el.observed) {
          this.observer.unobserve(el);
        }
        return;
      }
      var params = value;
      var isModule = type === BindingTypes.MODULE;
      if (!isModule && module) {
        params.f_module = module;
      }
      if (el.report && isEqual(el.report.params, params)) {
        return;
      }
      if (!el.report) {
        el.report = {
          type: type,
          params: params
        };
      }
      if (isModule) {
        el.report.params.f_type = ReportElementType.MODULE;
      } else {
        el.report.params = Object.assign(Object.assign({}, el.report.params), params);
      }
      if (once) {
        return;
      }
      // 注册 Dom 曝光上报
      var exposeTypes = [BindingTypes.MODULE, BindingTypes.ALL, BindingTypes.EXPOSE];
      if (exposeTypes.includes(type)) {
        if (el.observed) {
          this.observer.unobserve(el);
        }
        el.observed = true;
        this.observer.observe(el);
      }
      var clickTypes = [BindingTypes.ALL, BindingTypes.CLICK];
      // 首次注册时，未绑定点击事件
      if (clickTypes.includes(type) && !el.report.click) {
        el.report.click = function () {
          _this.report(el.report.params, EventType.CLICK);
        };
        el.addEventListener('click', el.report.click, true);
      }
    }
  }, {
    key: "pv",
    value: function pv() {
      this.report({
        f_type: ReportElementType.PAGE
      }, EventType.EXPOSE);
      if (!this.hasRealtimePVReported) {
        this.reportRealtimePV();
      }
    }
  }, {
    key: "reportRealtimePV",
    value: function reportRealtimePV() {
      this.hasRealtimePVReported = true;
      this.report({
        f_type: ReportElementType.REALTIME_PAGE
      }, EventType.EXPOSE, true);
    }
  }, {
    key: "createObserver",
    value: function createObserver(observerOptions) {
      var _this2 = this;
      return new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var target = entry.target,
            isIntersecting = entry.isIntersecting;
          if (isIntersecting) {
            _this2.report(target.report.params, EventType.EXPOSE);
          }
        });
      }, Object.assign({
        threshold: 0.1
      }, observerOptions));
    }
  }, {
    key: "buildReportParams",
    value: function buildReportParams(params, event) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var presetParams, extraParams;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                presetParams = this.presetParams;
                if (!(typeof this.extraParams === 'function')) {
                  _context2.next = 14;
                  break;
                }
                _context2.prev = 2;
                extraParams = this.extraParams();
                if (!isPromisable(extraParams)) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 7;
                return extraParams;
              case 7:
                extraParams = _context2.sent;
              case 8:
                presetParams = Object.assign(Object.assign({}, this.presetParams), extraParams);
                _context2.next = 14;
                break;
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                console.error('[boss-report.buildReportParams] merge extraParams error', _context2.t0);
              case 14:
                return _context2.abrupt("return", Object.assign(Object.assign(Object.assign(Object.assign({}, this.loginParams), presetParams), mapDt2BossParams(params)), {
                  f_event: event,
                  _dc: Math.random()
                }));
              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 11]]);
      }));
    }
  }, {
    key: "buildLoginParams",
    value: function buildLoginParams() {
      var currentLoginType = loginType();
      return {
        f_logintype: currentLoginType || '-',
        f_uid: getUid(),
        f_vuid: getVuid(),
        f_appid: cookie.get("".concat(currentLoginType === 'qq' ? 'vqq_' : '', "appid"))
      };
    }
  }, {
    key: "shouldReportRealtimePV",
    value: function shouldReportRealtimePV() {
      return this.enableRealtimePV && this.autoReportPVOnReady; // 如果是手动上报pv的场景，也不需要自动上报实时pv
    }
  }]);
  return BossReporter;
}();
export { BossReporter as default };